import type { ModelGradeBodyTypeIdsType } from "../../utils/newCarCompareTypes";
import {
    type NewCarCompareExternalDataActionsType,
    NEW_CAR_COMPARE_ADD_CAR,
    NEW_CAR_COMPARE_CLEAR_ALL,
    NEW_CAR_COMPARE_REMOVE_CAR,
    NEW_CAR_COMPARE_SET_FINANCE_PRODUCT,
} from "../actions/NewCarCompareExternalDataActions";

export type NewCarCompareExternalDataReducerType = {
    modelGradeBodyTypeIds: ModelGradeBodyTypeIdsType[];
    financeProduct: string | undefined;
};

export const initialNewCarCompareExternalDataState: NewCarCompareExternalDataReducerType = {
    modelGradeBodyTypeIds: [],
    financeProduct: undefined,
};

// See CompareReducer for more information
const replaceObjectInArray = <T>(array: T[], newObject: T, index: number): T[] => {
    return [...array.slice(0, index), newObject, ...array.slice(index + 1)];
};

const newCarCompareExternalDataReducer = (
    state: NewCarCompareExternalDataReducerType = initialNewCarCompareExternalDataState,
    action: NewCarCompareExternalDataActionsType,
): NewCarCompareExternalDataReducerType => {
    switch (action.type) {
        case NEW_CAR_COMPARE_CLEAR_ALL: {
            return {
                ...state,
                modelGradeBodyTypeIds: [],
            };
        }

        case NEW_CAR_COMPARE_ADD_CAR: {
            return {
                ...state,
                // When adding two cars at once the data gets added to the redux store in an array at a given index.
                // If say the second car (index 1) gets it's data first from the api it will store iets specs, grades, equipment... in the
                // 1 index of the array. But in this case the array is empty so it will save it in the 0 index, when after this the first
                // car receives its data from the api it will overwrite the data saved in index 0 of these arrays.
                // For this we add mockData for the grades and selectedEngines (we know the name so we only store these so it shows on screen)
                // and an empty array placeholder for the other data. This will reserve a place in the array when the data returns from the api.
                modelGradeBodyTypeIds: action.modelGradeBodyTypeIds
                    ? replaceObjectInArray(state.modelGradeBodyTypeIds, action.modelGradeBodyTypeIds, action.index)
                    : state.modelGradeBodyTypeIds,
            };
        }

        case NEW_CAR_COMPARE_REMOVE_CAR: {
            const indexToRemove = action.index;
            return {
                ...state,
                modelGradeBodyTypeIds: state.modelGradeBodyTypeIds.filter((item, index) => index !== indexToRemove),
            };
        }

        case NEW_CAR_COMPARE_SET_FINANCE_PRODUCT: {
            const { financeProduct } = action;
            return { ...state, financeProduct, modelGradeBodyTypeIds: [] };
        }

        default:
            return state;
    }
};

export default newCarCompareExternalDataReducer;
